module.exports = {
      id: "personas:one-usage",
      viewBox: "0 0 32 43",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#personas:one-usage",
      toString: function () {
        return this.url;
      }
    }